import { render } from "@/components/pages/obd/individual/obdOnboardSystemTest/ObdOnboardSystemTest.html?vue&type=template&id=5529711e&external"
import script from "@/components/pages/obd/individual/obdOnboardSystemTest/ObdOnboardSystemTest.js?vue&type=script&lang=js&external"
export * from "@/components/pages/obd/individual/obdOnboardSystemTest/ObdOnboardSystemTest.js?vue&type=script&lang=js&external"

import "@/components/pages/obd/individual/obdOnboardSystemTest/ObdOnboardSystemTest.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__